import { API } from '../constants/api';

import { axiosInterceptor } from './interceptors';

export const getDocumentsList = async (params: any) => {
    const response = await axiosInterceptor.get(API.DOCUMENTS.LIST, { params });

    return response;
};

export const getInvoicesList = async (params: any) => {
    const response = await axiosInterceptor.get(API.DOCUMENTS.INVOICES_LIST, { params });

    return response;
};

export const getInvoiceDetail = async (id: number) => {
    const response = await axiosInterceptor.get(`${API.DOCUMENTS.INVOICE_DETAIL}/${id}`);

    return response;
};

// Order context (addresses + schedule strings) for POD-only rows in the combined
// Invoice+POD table — those rows carry no invoice id to fetch getInvoiceDetail with.
export const getPodOrderContext = async (walOrderId: number) => {
    const response = await axiosInterceptor.get(`${API.DOCUMENTS.POD_ORDER_CONTEXT}/${walOrderId}`);

    return response;
};

export interface ITrackDocumentDownloadPayload {
    /** Portal document type, e.g. 'pod', 'invoice', 'bol'. Lower-cased by the backend. */
    docType: string;
    entityType: 'order' | 'invoice';
    entityId: number | string | null | undefined;
}

// Portal usage tracking (WALHQ Portal Activity). Files are downloaded straight from storage, so the
// frontend reports the download here. Fire-and-forget: never awaited by callers, never throws, and a
// missing entity id means there is nothing meaningful to record.
export const trackDocumentDownload = (payload: ITrackDocumentDownloadPayload): void => {
    const entityId = Number(payload.entityId);
    if (!Number.isInteger(entityId) || entityId <= 0) return;

    axiosInterceptor.post(API.DOCUMENTS.TRACK_DOWNLOAD, { ...payload, entityId }).catch(() => undefined);
};
